<template>
  <div :class="['container wide-banner', _isMobile() ? 'mobile' : '']">
    <Header />
    <div class="banner-wrap">
      <Banner />
    </div>
    <div class="home">
      <div
        class="sec-wrap"
        :style="'background-image:url(' + require('../assets/bg3.jpg') + ')'"
      >
        <div class="sec-content">
          <a-row
            class="zhuanti"
            type="flex"
            justify="space-between"
          >
            <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <div
                class="zhuanti-item animate__animated animate__fadeIn"
                @mouseenter="currentZhuanti1 = true"
                @mouseleave="currentZhuanti1 = false"
              >
                <img v-if="currentZhuanti1" v-bind:src="zhuantiBg[3]" />
                <img v-else v-bind:src="zhuantiBg[0]" />
                <a href="/scratch3/index.html" target="_blank"
                  ><h1>编程体验</h1></a
                >
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <div
                class="zhuanti-item animate__animated animate__fadeIn"
                @mouseenter="currentZhuanti2 = true"
                @mouseleave="currentZhuanti2 = false"
              >
                <img v-if="currentZhuanti2" v-bind:src="zhuantiBg[4]" />
                <img v-else v-bind:src="zhuantiBg[1]" />
                <!-- <router-link :to="{ path: '/event/list' }">
                  <h1>参与活动</h1>
                </router-link> -->
                <a href="https://www.gmw.cn/" target="_blank"><h1>参与活动</h1></a>
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <div
                class="zhuanti-item animate__animated animate__fadeIn"
                @mouseenter="currentZhuanti3 = true"
                @mouseleave="currentZhuanti3 = false"
              >
                <img v-if="currentZhuanti3" v-bind:src="zhuantiBg[5]" />
                <img v-else v-bind:src="zhuantiBg[2]" />
                <router-link :to="{ path: '/courseHome' }">
                  <h1>在线学习</h1>
                </router-link>
              </div>
            </a-col>
          </a-row>
          <a-row type="flex" justify="space-between">
            <a-col
              :gutter="20"
              :xs="24"
              :sm="24"
              :md="24"
              :lg="15"
              :xl="15"
              class="animate__animated animate__bounceInLeft"
            >
              <a-card
                class="column-card"
                :bordered="false"
              >
                <a-tabs default-active-key="1" @change="getCmsList">
                  <a-tab-pane key="1" tab="文件通知">
                    <a-list :dataSource="cmsDataSource">
                      <a-list-item
                        class="cms-item"
                        slot="renderItem"
                        slot-scope="item"
                        @click="toCmsDetail(item)"
                      >
                        <span class="cms-title">{{ item.cmsTitile }}</span>
                        <span class="cms-time">{{
                          item.createTime.split(" ")[0]
                        }}</span>
                      </a-list-item>
                    </a-list>
                  </a-tab-pane>
                  <a-tab-pane key="2" tab="新闻报道">
                    <a-list :dataSource="cmsDataSource">
                      <a-list-item
                        class="cms-item"
                        slot="renderItem"
                        slot-scope="item"
                        @click="toCmsDetail(item)"
                      >
                        <span class="cms-title">{{ item.cmsTitile }}</span>
                        <span class="cms-time">{{
                          item.createTime.split(" ")[0]
                        }}</span>
                      </a-list-item>
                    </a-list>
                  </a-tab-pane>
                  <a-tab-pane key="3" tab="地方动态">
                    <a-list :dataSource="cmsDataSource">
                      <a-list-item
                        class="cms-item"
                        slot="renderItem"
                        slot-scope="item"
                        @click="toCmsDetail(item)"
                      >
                        <span class="cms-title">{{ item.cmsTitile }}</span>
                        <span class="cms-time">{{
                          item.createTime.split(" ")[0]
                        }}</span>
                      </a-list-item>
                    </a-list>
                  </a-tab-pane>
                  <router-link
                    class="see-more"
                    slot="tabBarExtraContent"
                    :to="{ path: '/cms/list', query: { type: cmsType } }"
                    >查看更多>></router-link
                  >
                </a-tabs>
              </a-card>
            </a-col>
            <a-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="8"
              :xl="8"
              class="animate__animated animate__bounceInRight"
            >
              <a-card
                class="column-card video-card"
                :bordered="false"
              >
                <a-row type="flex" justify="space-between">
                  <a-col :span="12"><h3 style="font-size: 1.2rem;font-weight: bold;">精彩影像 ></h3></a-col>
                  <a-col :span="12">
                    <router-link class="see-more" to="/cms/video">
                      查看更多>>
                    </router-link>
                  </a-col>
                </a-row>
                <a-list
                  :grid="{ gutter: 16, xl: 2, lg: 2, md: 4, sm: 2, xs: 1 }"
                  :data-source="videoDataSource"
                >
                  <a-list-item slot="renderItem" slot-scope="item">
                    <div @click="toVideoDetail(item)">
                      <div class="img-zoom">
                        <img class="cover" :src="item.cmsCover_url" alt="" />
                      </div>
                      <a
                        ><h3 class="title">{{ item.cmsTitile }}</h3></a
                      >
                    </div>
                  </a-list-item>
                </a-list>
              </a-card>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="sec-wrap">
        <div class="sec-content">
          <!-- <div class="sec-title"><img src="../assets/act.png" alt="" /></div> -->
          <a-row
            type="flex"
            style="text-align: center"
            justify="space-between"
            :gutter="24"
          >
            <a-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16" class="event-info">
              <!-- <h1 style="font-weight: 700; font-size: 24px; color: #fff" @click="toEventDetail(homeEventInfo)">
                {{homeEventInfo.eventName}}
              </h1> -->
              <PhotoCard>
                <img
                  @click="toEventDetail(homeEventInfo)"
                  slot="img"
                  class="event-cover"
                  :src="homeEventInfo.eventCover_url"
                  :style="{height: !_isMobile()?'420px':'auto'}"
                />
                <div
                  @click="toEventDetail(homeEventInfo)"
                  slot="content"
                  class="event-desc"
                >
                  <div v-html="homeEventInfo.eventDesc"></div>
                </div>
              </PhotoCard>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
              <a-card
                class="column-card box-shadow"
                style="height: 420px"
                :bordered="false"
              >
                <div>
                  <a-avatar class="avatar" :size="100" :src="avatarUrl" />
                  <br />
                  <div v-if="$store.state.user.info">
                    <h3>{{ $store.state.user.info.realname }}</h3>
                    <a-button
                      style="display: block; margin: 20px auto"
                      @click="showApplyEvent"
                      >活动报名</a-button
                    >
                    <a-button
                      style="display: block; margin: auto"
                      @click="toCenter"
                      >申请证件</a-button
                    >
                  </div>
                  <div v-else>
                    <br />
                    <h3>您还没有登录</h3>
                    <br />
                    <a-button
                      style="display: block; margin: auto"
                      @click="toLogin"
                      >去登录</a-button
                    >
                  </div>
                  <a-divider></a-divider>
                  <p>地点：{{ homeEventInfo.eventAddress }}</p>
                  <p>时间：{{ homeEventInfo.eventBegin }}</p>
                  <div>
                    <a-button type="link" @click="toCertQuery"
                      >证书查询</a-button
                    >
                    <a-button type="link" @click="toForm">问卷调查</a-button>
                  </div>
                </div>
              </a-card>
            </a-col>
          </a-row>
        </div>
      </div>
      <!-- 日程安排 -->
      <div
        class="sec-wrap"
        :style="'background-image:url(' + require('../assets/bg4.jpg') + ')'"
      >
        <div class="sec-content">
          <!-- <h1 class="sec-title" v-if="timeline.length>0">日程安排</h1> -->
          <div class="sec-title" v-if="timeline.length > 0">
            <img src="../assets/sche.png" alt="" />
          </div>
          <div
            class="animate__animated animate__fadeIn"
            v-if="timeline.length > 0"
          >
            <vue-horizontal-timeline
              timelineBackground="transparent"
              :items="timeline"
              :titleSubstr="50"
              minWidth="250px"
            />
          </div>
        </div>
      </div>
      <!-- 故事分享 -->
      <div class="sec-wrap">
        <div class="sec-content">
          <div class="sec-title" v-if="timeline.length > 0">
            <img src="../assets/gushi.png" alt="" />
          </div>
          <!-- <h1 class="sec-title">故事分享</h1> -->
          <div class="store">
            <a-list
              :grid="{
                gutter: _isMobile() ? 12 : 24,
                lg: 4,
                md: 4,
                sm: 2,
                xs: 1,
              }"
              :dataSource="storeDataSource"
            >
              <a-list-item
                class="store-item animate__animated animate__fadeIn"
                slot="renderItem"
                slot-scope="item"
                @click="toCmsDetail(item)"
              >
                <div class="img-zoom">
                  <img class="cover" :src="item.cmsCover_url" alt="" />
                </div>
                <h3 class="title">{{ item.cmsTitile }}</h3>
              </a-list-item>
            </a-list>
          </div>
        </div>
      </div>
      <!-- 科普名人堂 -->
      <div class="sec-wrap">
        <div class="sec-content">
          <div class="sec-title" v-if="timeline.length > 0">
            <img src="../assets/people.png" alt="" />
          </div>
          <!-- <h1 class="sec-title">科普名人堂</h1> -->
          <router-link
            class="see-more"
            style="color: #000"
            slot="tabBarExtraContent"
            :to="{ path: '/cms/people' }"
            >查看更多>></router-link
          >
          <br />
          <div class="people">
            <a-list
              :grid="{
                gutter: _isMobile() ? 12 : 24,
                lg: 4,
                md: 4,
                sm: 2,
                xs: 1,
              }"
              :dataSource="peopleDataSource"
            >
              <a-list-item
                class="animate__animated animate__fadeIn people-item"
                slot="renderItem"
                slot-scope="item"
              >
                <div @click="toCmsDetail(item)">
                  <a-avatar
                    class="avatar"
                    :size="100"
                    :src="item.cmsCover_url"
                  />
                  <p>{{ item.cmsTitile }}</p>
                  <p>浏览数：{{ item.viewNum }}</p>
                  <p>{{ item.cmsDesc }}</p>
                </div>
                <!-- <h3 class="title">{{ item.cmsTitile }}</h3> -->
              </a-list-item>
            </a-list>
          </div>
        </div>
      </div>
      <div
        class="sec-wrap"
        :style="'background-image:url(' + require('../assets/bg5.jpg') + ')'"
      >
        <div class="sec-content">
          <div class="animate__animated animate__fadeIn">
            <div class="sec-title" v-if="timeline.length > 0">
              <img src="../assets/old.png" alt="" />
            </div>
            <!-- <h1 class="sec-title">往届回顾</h1> -->
            <router-link
              class="see-more"
              style="color: #fff"
              slot="tabBarExtraContent"
              :to="{ path: '/cms/pic' }"
              >查看更多>></router-link
            >
            <br />
            <br />
          </div>
          <div class="event-pic">
            <swiper
              ref="mySwiper"
              :options="swiperOptions"
              class="swiper-wrappe carousel"
            >
              <swiper-slide
                class="swiper-slide"
                v-for="(b, i) in picDataSource"
                :key="i"
              >
                <img :src="b.cmsCover_url" alt="" @click="toPicDetail(b)" />
              </swiper-slide>

              <!-- 分页器 -->
              <div
                v-show="oldEventPic && oldEventPic.length > 1"
                class="swiper-pagination swiper-pagination-white"
                slot="pagination"
              ></div>
              <!-- 左右箭头 -->
              <div
                v-show="oldEventPic && oldEventPic.length > 1"
                class="swiper-button-prev swiper-button-white"
                slot="button-prev"
              ></div>
              <div
                v-show="oldEventPic && oldEventPic.length > 1"
                class="swiper-button-next swiper-button-white"
                slot="button-next"
              ></div>
            </swiper>
          </div>
          <br />
          <div class="event-video">
            <router-link
              class="see-more"
              style="color: #fff"
              slot="tabBarExtraContent"
              :to="{ path: '/cms/video' }"
              >查看更多>></router-link
            >
            <br />
            <a-list
              :grid="{
                gutter: _isMobile() ? 12 : 24,
                lg: 4,
                md: 4,
                sm: 2,
                xs: 1,
              }"
              :dataSource="videoDataSource"
            >
              <a-list-item
                class="animate__animated animate__fadeIn"
                slot="renderItem"
                slot-scope="item"
              >
                <div class="img-zoom" @click="toVideoDetail(item)">
                  <img class="cover" :src="item.cmsCover_url" alt="" />
                </div>
                <!-- <h3 class="title">{{ item.cmsTitile }}</h3> -->
              </a-list-item>
            </a-list>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      :width="800"
      :visible="videoVisible"
      :maskClosable="false"
      :title="currentVideo.cmsTitile"
      :destroyOnClose="true"
      @cancel="videoVisible = false"
      :footer="null"
    >
      <video
        style="width: 100%"
        controls
        autoplay
        oncontextmenu="return false;"
        controlsList="nodownload noremote footbar"
        :src="currentVideo.extraFile_url"
      ></video>
    </a-modal>
    <EventApplyModal ref="applyModal" />
    <LightBox
      :showLightBox="false"
      ref="lightbox"
      :showCaption="true"
      :media="lightBoxMedia"
    ></LightBox>
    <a-back-top />
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { getAction, postAction } from "@/api/manage";
import { getArticleList } from "@/api/article";
import { mixinDevice } from "@/utils/mixin.js";
import { getInfo } from "@/api/login";
import EventApplyModal from "./modal/EventApplyModal";
import PhotoCard from "@/components/common/PhotoCard";
import "@/assets/less/animation.css";
import VueHorizontalTimeline from "@/components/common/VueHorizontalTimeline";
import LightBox from "vue-image-lightbox";
import { jumpMixins } from "@/utils/jumpMixins";
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");

export default {
  name: "Home",
  mixins: [mixinDevice, jumpMixins],
  components: {
    PhotoCard,
    VueHorizontalTimeline,
    LightBox,
    EventApplyModal,
    Header,
    Banner,
    Footer,
  },
  data() {
    return {
      bgUrl: "/assets/background.svg",
      zhuantiBg: [
        require("../assets/card-bg1.png"),
        require("../assets/card-bg2.png"),
        require("../assets/card-bg3.png"),
        require("../assets/card-bg4.png"),
        require("../assets/card-bg5.png"),
        require("../assets/card-bg6.png"),
      ],
      currentZhuanti1: false,
      currentZhuanti2: false,
      currentZhuanti3: false,
      articleList: [],
      videoVisible: false,
      currentVideo: {},
      cmsDataSource: [],
      cmsType: 1,
      videoDataSource: [],
      picDataSource: [],
      tenantConfig: {},
      token: "",
      peopleDataSource: [],
      storeDataSource: [],
      homeEventInfo: {},
      timeline: [],
      //swiperOptions:  http://t.zoukankan.com/xiaocaiyuxiaoniao-p-10521462.html
      swiperOptions: {
        speed: 1000,
        // autoHeight: true,
        effect: this._isMobile() ? "fade" : "coverflow", //"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        slidesPerView: 2,
        grabCursor: true,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: -100,
          depth: 700,
          modifier: 0.5,
          slideShadows: false,
        },
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 3000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: true,
        },
        //开启循环模式
        loop: true,
      },
      oldEventPic: [],
      lightBoxMedia: [],
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
    if (this.tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
    this.getHomeEvent();
    this.getVideoList();
    this.getPicList();
    this.getCmsList(1);
    this.getPeopleList();
    this.getStoreList();
  },
  mounted() {},
  computed: {
    avatarUrl() {
      return this.$store.state.user.info && this.$store.state.user.info.avatar
        ? "https://cast-files.oss-cn-beijing.aliyuncs.com/" +
            this.$store.state.user.info.avatar
        : "/img/avatar.png";
    },
  },
  methods: {
    zhuantiEnter(i) {
      this.currentZhuantiBg[i] = true;
    },
    zhuantiLeave(i) {
      this.currentZhuantiBg[i] = false;
    },
    tabChange(key) {},
    getUserInfo() {
      getInfo().then((res) => {
        console.log(res);
      });
    },
    showApplyEvent() {
      if (Vue.ls.get(ACCESS_TOKEN)) {
        // this.$refs.applyModal.open(this.homeEventInfo.id);
        this.$router.push({
          path: "/event/apply",
          query: { id: this.homeEventInfo.id },
        });
      } else {
        this.toLogin();
      }
    },
    getHomeEvent() {
      getAction("/teaching/teachingEvent/getHomeEvent").then((res) => {
        if (res.success) {
          this.homeEventInfo = res.result;
          this.timeline = this.homeEventInfo.teachingEventScheList.map((s) => {
            return {
              content: s.scheTime,
              title: s.scheDesc,
            };
          });
        } else {
          this.$message.info(res.message);
        }
      });
    },
    toEventDetail(item) {
      // let route = this.$router.resolve({
      //   path: "/event/detail",
      //   query: {
      //     id: item.id,
      //   },
      // });
      // window.open(route.href, "_blank");

      window.open('https://www.gmw.cn/')
    },
    getCmsList(type) {
      this.cmsType = type;
      this.cmsDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: type,
        pageSize: 10,
      }).then((res) => {
        if (res.success) {
          this.cmsDataSource = res.result.records;
        }
      });
    },
    toCmsDetail(item) {
      let route = this.$router.resolve({
        path: "/cms/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, "_blank");
    },
    toCertQuery() {
      let route = this.$router.resolve({
        path: "/cert/query",
      });
      window.open(route.href, "_blank");
    },
    toForm() {
      window.open("http://yfafddsd2zap3lh2.mikecrm.com/wZVHTDB");
    },
    getVideoList() {
      this.videoDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: 5,
        pageSize: 6,
      }).then((res) => {
        if (res.success) {
          this.videoDataSource = res.result.records;
        }
      });
    },
    getPicList() {
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: 10,
        pageSize: 10,
      }).then((res) => {
        if (res.success) {
          this.picDataSource = res.result.records;
          this.oldEventPic = this.picDataSource.map((i) => {
            return {
              img: i.cmsCover_url,
              href: "#",
            };
          });
        }
      });
    },
    getPeopleList() {
      this.peopleDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsType: 7,
        pageSize: 4,
        cmsStatus: 1,
      }).then((res) => {
        console.log(res);
        if (res.success) {
          this.peopleDataSource = res.result.records;
        }
      });
    },
    getStoreList() {
      this.storeDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsType: 4,
        pageSize: 4,
        cmsStatus: 1,
      }).then((res) => {
        console.log(res);
        if (res.success) {
          this.storeDataSource = res.result.records;
        }
      });
    },
    toVideoDetail(item) {
      this.currentVideo = item;
      this.videoVisible = true;
      //使阅读量+1
      getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id);
    },
    toPicDetail(item) {
      //使阅读量+1
      getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id);
      let that = this;
      let fileNames = [];
      if (item.extraFilename) {
        fileNames = JSON.parse(item.extraFilename);
        console.log(fileNames);
      }
      if (item.extraFile) {
        this.lightBoxMedia = item.extraFile.split(",").map((f) => {
          let fn = "";
          if (f in fileNames) {
            fn = fileNames[f];
          }
          return {
            thumb: that.getQiniuUrl(f),
            src: that.getQiniuUrl(f),
            caption: fn,
          };
        });
        this.$refs.lightbox.showImage(0);
      } else {
        //this.$message.warning("没有图像")
      }
    },
    getQiniuUrl(text) {
      if (!text) {
        this.$message.warning("未知的文件");
        return;
      }
      if (text.indexOf(",") > 0) {
        text = text.substring(0, text.indexOf(","));
      }
      if (text.startsWith("http")) {
        return text;
      }
      return this.tenantConfig.qiniuDomain + "/" + text;
    },
  },
};
</script>

<style lang="less" scoped>
// 宽banner主题
.wide-banner {
  .banner {
    width: 100% !important;
    max-width: 100% !important;
  }
  .header {
    z-index: 99;
    position: absolute;
    background: #18239fa8;
    width: 100%;
  }
}
.container {
  .banner-wrap {
    .banner-bg {
      position: absolute;
      width: 100%;
    }
    .banner {
      margin: auto;
      max-width: 1200px;
      overflow: hidden;
      border-radius: 0 0 10px 10px;
    }
  }
  .home {
    // max-width: 1200px;
    // margin: 20px auto;
    // padding: 20px 10px;
    // background: #ffffff4a;
    // border-radius: 30px;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
  // background: url(../assets/bg2.jpg);
}

.box-shadow {
  box-shadow: #00000026 0px 0px 6px 0px;
}
.sec-wrap {
  // background-image:url(../assets/bg4.jpg)
  background-size: cover;
}
.sec-content {
  max-width: 1200px;
  margin: auto;
  padding: 30px 10px;
}
.sec-title {
  text-align: center;
  margin-top: 20px;
  font-weight: 700;
  font-size: 24px;
  color: #ffffff;
  text-shadow: #000 0px 0px 4px;
  img {
    text-align: center;
    max-height: 6rem;
    max-width: 100%;
    margin-bottom: 30px;
  }
}
.column-card {
  background: transparent;
  border-radius: 10px;
  margin-bottom: 5px;
  .cms-item {
    cursor: pointer;
    transition: color 0.2s;
  }
  .cms-item:hover {
    color: #1890ff;
  }
  .cms-title {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .cms-time {
    text-align: right;
    width: 150px;
  }
  /deep/.ant-tabs-tab {
    font-size: 1rem;
    color: #000;
  }
}

.video-card {
  .cover {
    border-radius: 10px;
    width: 100%;
    min-height: 120px;
    // max-height: 140px;
  }
  .title{
    margin-top: 10px;
  }
}
.see-more {
  color: black;
  text-align: right;
  float: right;
}
.see-more:hover {
  color: #1890ff;
}

.zhuanti {
  .zhuanti-item {
    height: 72px;
    width: 249px;
    display: block;
    margin: 10px auto;
    cursor: pointer;
    img {
      height: 72px;
      width: 249px;
    }
    h1 {
      position: relative;
      top: -58px;
      left: 0;
      text-align: center;
      color: #fff;
      text-shadow: #000 0px 0px 4px;
    }
  }
  margin-bottom: 50px;
}
.news {
  height: 50px;
}

.event-info{
  .event-cover{
    width: 100%; 
    max-height: 420px; 
    border-radius: 10px
  }
  .event-desc {
  width: 40%;
  margin: auto;
  background-color: #0000008f;
  border-radius: 20px;
  padding: 10px;
  /deep/ * {
    background-color: unset !important;
  }
}
}

.common-title {
  h3 {
    font-size: 24px;
    font-weight: normal;
    line-height: 24px;
  }
}

.item-card {
  cursor: pointer;
  /deep/.ant-card-body {
    padding: 0;
    margin-top: 0;
    margin-bottom: 25px;
  }
  .cover {
    width: 100%;
    height: 170px;
    margin-bottom: 10px;
  }
}
.title {
  color: black;
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 0;
  overflow: hidden;
}
.title:hover {
  color: #1890ff;
}

.event-pic {
  margin-bottom: 20px;
  .swiper-slide{
    img{
      border-radius: 20px;
    }
  }
}
.event-video {
  margin-top: 20px;
  .img-zoom {
    height: 200px;
    border: rgb(192, 192, 192) solid 1px;
    border-radius: 5px;
    .cover {
      height: 100%;
      width: 100%;
    }
  }
}
.store {
  margin-top: 20px;
  .ant-card {
    height: 250px;
  }
  .store-item {
    overflow: hidden;
    margin-bottom: 1rem;
    .cover {
      height: 200px;
      max-width: 400px;
      width: 100%;
      border-radius: 20px;
      display: block;
      margin: auto;
    }
    .title {
      text-align: center;
      margin-top: 1rem;
      font-size: 1rem;
      text-indent: 1rem;
      color: black;
      font-weight: bold;
    }
    .title:hover{
      cursor: pointer;
    }
  }
}
.people {
  margin-top: 20px;
  .avatar {
    margin-bottom: 20px;
  }
  .people-item {
    color: black;
  }
  cursor: pointer;
  text-align: center;
}

.vue-horizontal-timeline {
  box-shadow: none !important;
  /deep/.timeline {
    overflow-x: auto;
  }
  /deep/.timeline::-webkit-scrollbar {
    display: none;
    width: 10px;
    background-color: #f5f5f5;
    border-radius: 10px;
  }
  /deep/.timeline::-webkit-scrollbar-thumb {
    display: none;
    background-color: rgb(27, 110, 219);
    border-radius: 10px;
    background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
  }
}

.carousel {
  max-height: 400px;
  img {
    // height: 300px;
    width: 100%;
    max-width: 600px;
  }
}

.mobile {
  .header{
    position: relative !important;
    background: #4c79ff!important;
  }
  .item-card {
    /deep/.ant-card-body {
      margin-bottom: 12px !important;
    }
    .cover {
      height: 100px !important;
    }
  }
}
</style>